import React from "react";
import { Routes, Route } from "react-router-dom";
import EditAbout from "./edit-about";
import AboutDetail from "../../public/about/about-detail";

//
const About = () => {
  return (
    <React.Fragment>
      <Routes>
        <Route path="" element={<AboutDetail />} />
         <Route path="/" element={<AboutDetail />} />
         <Route path="/edit" element={<EditAbout />} />
      </Routes>
    </React.Fragment>
  );
};

export default About;
